import React from 'react';
import { Box, CircularProgress, fade } from '@material-ui/core';
import { grey, white } from 'globals/colors';

interface FsAbsoluteLoaderProps {
  backgroundColor?: string;
  loaderColor?: string;
}

const FsAbsoluteLoader: React.FC<FsAbsoluteLoaderProps> = ({
  backgroundColor,
  loaderColor,
}) => {
  return (
    <Box
      position="absolute"
      top={0}
      left={0}
      right={0}
      bottom={0}
      display="flex"
      alignItems="center"
      justifyContent="center"
      style={{
        backgroundColor: fade(backgroundColor || white, 0.5),
      }}
    >
      <CircularProgress style={{ color: loaderColor || grey.V4 }} />
    </Box>
  );
};

export default FsAbsoluteLoader;
